module.exports = __webpack_public_path__ + "static/media/10-speaker_profile.f510713d.webp";